export default {
    data() {
        return {};
    },
    methods: {
        replaceByDefault(e) {
            const imageUrl = this.tyre?.image_url || '';
            const imageBaseUrl = imageUrl.includes('/Images/')
                ? imageUrl.split('/Images/')[0]
                : 'https://colewood-automotive.s3-eu-west-1.amazonaws.com';

            e.target.src = imageBaseUrl + '/Images/coming_soon.png';
        },
        replaceBrandByDefault(e) {
            const brandImageUrl = this.tyre?.brand_image_url || '';
            const imageBaseUrl = brandImageUrl.includes('/Images/')
                ? brandImageUrl.split('/Images/')[0]
                : 'https://colewood-automotive.s3-eu-west-1.amazonaws.com';

            e.target.src = imageBaseUrl + '/Images/brand_logos/generic.png';
        },
    },
    computed: {
        tyreText() {
            return this.inBasket ? 'In Basket' : 'Buy';
        },
        buttonColour() {
            return this.inBasket ? 'bg-dark-blue' : 'green-bg';
        },
        tyreBorder() {
            let border = 'grey';

            if(this.featuredTopSpotFlag == true || this.featured == true) {
                border = 'blue';
            }
            if(this.inBasket)
            {
                border = 'blue';
            }

            return border;
        },
        showBanner() {
            if(Object.keys(this.banners).length > 0) {
                let qualifyingBanner = this.banners.filter((banner) => {
                    if(banner.short_content != null && banner.short_content != '' && typeof(banner.short_content != 'undefined')) {
                        return banner?.qualifying_products?.includes(this.tyre.st_code)
                    }
                });

                return qualifyingBanner.length ? true : false;
            }
        },
        inFeatured: function() {
            let vm = this;
            if(this.$parent.featuredTyres) {
                let items = this.$parent.featuredTyres;
                
                let result = Object.keys(items).map(key => items[key]).filter((item) => {
                    return item.st_code == vm.tyre.st_code;
                });
                
                //Checks to see if the tyre is in the Featured Tyres section, or if the Featured Top Spot flag is true
                return result.length > 0 ? true : false;
            }
            else if(vm.featuredTopSpotFlag == true) {
                return true;
            }
            else {
                return false;
            }
        },
        inBasket: function() {
            if(this.$parent.basket.products) {
                let query = this.$parent.basket.products.filter((basket_product) => {
                    return (basket_product.st_code == this.tyre.st_code);
                });

                return query.length > 0 ? true : false;
            }
        }
    }
};
